import React from 'react';
import { Button } from '@hpstellar/core';

import withPageComponents from '../../../../page/components/with-page-components';
import SimilarProductsLink from '../similar-products-link';
import './end-of-life-cta.less';

export const EoLLink = ({ productInitial, variation = 'secondary' }) => {
    if (!productInitial || !productInitial.eol) {
        return null;
    }

    const { ctaEol = 'VIEW ALTERNATE PRODUCT', ctaEolUrl } = productInitial;
    if (!ctaEolUrl) {
        return null;
    }
    return (
        <Button variation={variation} to={ctaEolUrl} className="eol-cta">
            {ctaEol}
        </Button>
    );
};

const EndOfLifeCTA = ({ productInitial }) => {
    if (!productInitial || !productInitial.eol) {
        return null;
    }
    const { ctaReplacementURL, ctaAddToCart, ctaEolUrl } = productInitial;
    const hasReplacement = !!ctaReplacementURL;
    const discontinued = ctaAddToCart === 'DISCONTINUED';
    const replaceMentCTA = hasReplacement || discontinued ? ctaAddToCart : 'NOT AVAILABLE';
    return (
        <>
            <div className={`end-of-life-cta${ctaEolUrl || ctaReplacementURL ? ' flex' : ''}`}>
                {(ctaEolUrl || ctaReplacementURL) && (
                    <Button disabled={!hasReplacement} to={ctaReplacementURL} className="eol-cta">
                        {replaceMentCTA}
                    </Button>
                )}
                {!ctaEolUrl && !ctaReplacementURL && (
                    <Button disabled={true} className="eol-cta">
                        {ctaAddToCart}
                    </Button>
                )}
                <EoLLink productInitial={productInitial} />
            </div>
            <div className="eol-similar-products">
                <SimilarProductsLink />
            </div>
        </>
    );
};

export default withPageComponents(EndOfLifeCTA, { components: ['productInitial'] });
